import React from 'react';

import {getSecondaryText} from 'ui-library/chips/EntryChip';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {SmartChipType} from 'ui-library/chips/useSmartChipQuery';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';

import {getSharedSmartChipProps, SharedSmartChipProps} from './ChipUtil';

export interface StageEntryChipProps extends SharedSmartChipProps<SmartChipType.STAGE_ENTRY> {
  id: string;
}

export default function StageEntryChip(props: StageEntryChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: stageEntry,
    handleClickLink,
    isInaccessible,
    itemUrl,
  } = useSmartChipQuery<SmartChipType.STAGE_ENTRY>({
    id,
    onClick,
    getUrlFn: ({editUrl}) => editUrl,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={FolderItemIcon.Entry}
      isInaccessible={isInaccessible}
      item={stageEntry}
      onClick={handleClickLink}
      url={itemUrl}
      getSecondaryText={getSecondaryText}
    />
  );
}
